import {
    RATEQUOTE_LIST,
    RATEQUOTE_PAGINATION,
    RATEQUOTE_SUMMARY,
} from './constant';

export const initStateFeed = {
    rateQuoteList: [],
    pagination: {},
    summary: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case RATEQUOTE_LIST: {
            return {
                ...state,
                rateQuoteList: action.payload,
            };
        }
        case RATEQUOTE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case RATEQUOTE_SUMMARY: {
            return {
                ...state,
                summary: action.payload,
            };
        }
        default:
            return state;
    }
};
